import { parcelTypes } from '@/parcels/constants'

import ParcelInfoCardInbound from './ParcelInfoCardInbound'
import ParcelInfoCardOutbound from './ParcelInfoCardOutbound'
import ParcelInfoCardTracking from './ParcelInfoCardTracking'

export const parcelInfoCardVariants = {
  [parcelTypes.outbound]: { ParcelInfoSections: ParcelInfoCardOutbound, hasManagedLogistics: true },
  [parcelTypes.inbound]: { ParcelInfoSections: ParcelInfoCardInbound, hasManagedLogistics: true },
  [parcelTypes.tracking]: { ParcelInfoSections: ParcelInfoCardTracking, hasManagedLogistics: false },
}
